export default __webpack_public_path__ + "static/media/pattern.3abfa05a.jpg";